import { render, staticRenderFns } from "./OverviewProfileInsights.vue?vue&type=template&id=3834ed8c"
import script from "./OverviewProfileInsights.vue?vue&type=script&lang=js"
export * from "./OverviewProfileInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports